"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.TableContainer = exports.Table = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_table_1 = require("react-table");
const style_1 = __importDefault(require("style"));
const Body_1 = require("./Body");
const Header_1 = require("./Header");
const util_1 = require("./util");
__exportStar(require("./type"), exports);
exports.Table = styled_components_1.default.table `
  border-collapse: collapse;
  border: none;
  width: 100%;
`;
exports.TableContainer = styled_components_1.default.div `
  ${style_1.default.Depth.Definition.LightShadow};
  background: ${props => props.theme.Color.Layout.Lightest};
  border-radius: ${style_1.default.Design.Rounding.Secondary};
  overflow: auto;
`;
function Grid(props) {
    const { data, columnSchemas } = props;
    const columns = react_1.default.useMemo(() => {
        return R.map(util_1.columnSchemaToColumn, columnSchemas);
    }, [columnSchemas]);
    const table = (0, react_table_1.useTable)({ columns, data });
    const { getTableProps } = table;
    return ((0, jsx_runtime_1.jsx)(exports.TableContainer, { children: (0, jsx_runtime_1.jsxs)(exports.Table, Object.assign({}, getTableProps(), { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, { table: table }), (0, jsx_runtime_1.jsx)(Body_1.Body, { table: table })] })) }));
}
exports.Grid = Grid;
